import { useEffect, useState } from 'react';

import { entitiesRefreshed } from '../events/entitiesRefreshed.event';
import { calculateLastOffsetAction } from '../utils/entities.utils';
import { entitySelectedFromSearchPalette } from 'src/events/entitySelectedFromSearchPalette.event';

const previousOffset: { prev?: number } = {};
const nextOffset: { current?: number } = {};

export const useLastOffset = (lastOffset?: number) => {
  const [entitiesLiveUpdated, setEntitiesLiveUpdated] = useState(false);
  const [offsetDifference, setOffsetDifference] = useState(0);

  nextOffset.current = lastOffset;

  useEffect(() => {
    const action = calculateLastOffsetAction({
      prevLastOffset: previousOffset.prev,
      nextLastOffset: lastOffset,
    });

    if (action === 'updated' && lastOffset && previousOffset?.prev !== undefined) {
      setEntitiesLiveUpdated(true);
      setOffsetDifference(lastOffset - previousOffset?.prev);
    }

    if (action === 'not-updated') {
      setEntitiesLiveUpdated(false);
      setOffsetDifference(0);
    }

    if (!previousOffset.prev && lastOffset) {
      previousOffset.prev = lastOffset;
    }
  }, [lastOffset]);

  useEffect(() => {
    const removeListener = entitiesRefreshed.on(() => {
      setEntitiesLiveUpdated(false);
      setOffsetDifference(0);
      previousOffset.prev = nextOffset.current;
    });

    return () => {
      removeListener();
      previousOffset.prev = undefined;
    };
  }, []);

  useEffect(() => {
    const removeListener = entitySelectedFromSearchPalette.on(() => {
      previousOffset.prev = undefined;
    });

    return () => removeListener();
  }, []);

  return {
    entitiesLiveUpdated,
    offsetDifference,
  };
};
